<template>
  <div class="account main">
    <div class="mt20">
      <span class="title1">付款</span>
    </div>
    <div class="mt50 f16 pl50">
      <h3 class="">单号：{{client_bill_no}}</h3>
      <p class="mt20 mb20 f1">类型：{{bill_type}}</p>
      <h2>合计：$ {{total_fee}}</h2>
      <p class="mt20 pl50">
        当前账户余额 $ {{current_amount}}
         <button class="ivu-btn" @click="goToBillCharge()">去充值</button>
      </p>
      <div class="mt50 ml50"> <button class="ivu-btn ivu-btn-primary" @click="pay()">支付</button></div>

    </div>
  </div>

</template>

<script>
  export default {
    data() {
      return {
        check: false, //复选框
        client_bill_no: '',
        total_fee: 0, //订单金额
        pay_fee: 0, //剩余需支付金额
        current_amount: 0, //账户余额
        bill_type: '', // 结算类型
        type_config: {
          0: '即时结算',
          10: '日结算',
          20: '周结算',
          30: '月结算',
          40: '季度结算',
        },
      }
    },
    methods: {
      pay() { //去支付
      this.$Modal.confirm({
                          title: '再次确认',
                          content: '<p>您确定更要支付这个账单吗？此操作不可撤销</p >',
                          onOk: () => {

                            this.$axios.post("/ClientBill/fee/pay", this.$qs.stringify({
                              client_bill_no: this.client_bill_no
                            })).then(res => {
                                if(res.success){
                                  this.$router.push({
                                    path:'/Finance/Bill'
                                  })
                                }
                            });
                          },
                          onCancel: () => {

                          }
                      });


      },
      getAmount() { //查询账户余额
        this.$axios.get('/dashboard/client/account').then(res => {
          if (res.success && res.data) {
            this.current_amount = res.data.current_amount || 0
          }
        })
      },
      checkChanged(e) { //复选框
        if(e){ //选中状态
          if(this.current_amount < 0 ){
            return false
          }
          if(this.current_amount >= this.total_fee){
            this.pay_fee = 0
          }else{
            this.pay_fee = this.total_fee - this.current_amount
          }
        }else{
          this.pay_fee = this.total_fee;
        }
      },
      goToBillCharge(){
        this.$router.push({
          path:'/Finance/Recharge'
        })
      }
    },
    created() {
      this.client_bill_no = this.$route.query.client_bill_no
      this.total_fee = this.$route.query.total_fee || 0;
      this.pay_fee = this.total_fee;
      if (this.$route.query.bill_type) {
        this.bill_type = this.type_config[this.$route.query.bill_type]
      }
      this.getAmount()
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/finance/bill/paying.vue